export default "__VITE_ASSET__CyOQWLp$__"